import React from 'react';
import Navbar from '../components/Navbar';
import FittingRoomContainer from '../components/FittingRoomContainer';

export default function fittingroom() {
    return (
        <section className="fittingroom">
            <Navbar />
            <FittingRoomContainer />
        </section>
    );
}
